module.exports = __webpack_public_path__ + "img/pwa-mac-2.c1224e53.jpeg";